export enum EFileStatus {
  LOCAL = "local",
  LOADING = "loading",
  UPLOADED = "uploaded",
  SAVED = "saved",
  ERRORED = "errored",
}
